import { render } from "./MiniWizardStickySubmit.vue?vue&type=template&id=48004cf0"
import script from "./MiniWizardStickySubmit.vue?vue&type=script&lang=js"
export * from "./MiniWizardStickySubmit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__